<script lang="ts">
  import VideoBanner from './VideoBanner.svelte'
  import type { BannerData } from 'shared/javascripts/video_banners/types'

  let {
    banners,
    container,
    onPause,
    onQuizRequested,
    onLearningExercisesRequested,
    element = $bindable(),
  }: {
    banners: BannerData[]
    container?: HTMLElement
    onPause: () => void
    onQuizRequested?: () => void
    onLearningExercisesRequested?: (event: MouseEvent, url: string) => void
    element?: HTMLElement
  } = $props()

  const shownBanners = $derived(
    banners.filter((banner) => banner.kind !== 'quiz' || onQuizRequested),
  )
</script>

<div class="video-banners" bind:this={element}>
  {#each shownBanners as banner, index (index)}
    <VideoBanner {banner} {container} {onPause} {onQuizRequested} {onLearningExercisesRequested} />
  {/each}
</div>
